<div style="display: flex;flex-direction: column;" class="mermaid-wrapper">
  <div class="table-header visualizer-header">
    <div class="header">
      <svg-icon src="assets\images\svg\icon_visualizer.svg"></svg-icon> {{
      'VISUALIZER' | translate }}
    </div>
    <div class="action-icons d-flex">
      <img src="assets\images\icon_zoom_in.png" class="icon-style" alt="Zoom In" (click)="zoomIn()">
      <img src="assets\images\icon_zoom_out.png" class="icon-style" alt="Zoom Out" (click)="zoomOut()">
      <img src="assets\images\icon_full_screen.png" class="icon-style icon-expand" alt="Fit to Screen"
        (click)="fitToScreen()" *ngIf="!isFullScreen">
      <img src="assets\images\icon_small_screen.png" class="icon-style icon-collapse d-none" alt="Fit to Main Screen"
        (click)="fitToScreen()" *ngIf="!isFullScreen">
      <!-- <img src="assets\images\icon_close.png" class="icon-style" alt="Close Visualizer" (click)="closeVisualizer()" *ngIf="isFullScreen"> -->
    </div>
  </div>
  <div class="mermaid-container">
    <div #mermaid id="workflow" class="mermaid">
    </div>
  </div>
</div>